var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "body-custom-item" }, [
    _c("div", { staticClass: "item-title" }, [
      _vm._v("\n    Event submission message\n  ")
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "item-body-detail" },
      [
        _c("vue-editor", {
          class: _vm.isDefault ? "default-message" : null,
          attrs: { id: "submission-message" },
          model: {
            value: _vm.message,
            callback: function($$v) {
              _vm.message = $$v
            },
            expression: "message"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grp-button-action" },
      [
        _c(
          "b-button",
          {
            staticClass: "item-reset-btn",
            on: {
              click: function($event) {
                _vm.resetMessage()
              }
            }
          },
          [
            _c("span", { staticClass: "dt-group-btn-func-btn-left-text" }, [
              _vm._v("RESET MESSAGE")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "b-button",
          {
            staticClass: "item-save-btn dt-group-btn-func-btn-right",
            attrs: { disabled: !_vm.canSave },
            on: {
              click: function($event) {
                _vm.saveMessage("SUBMISSION")
              }
            }
          },
          [
            _c("Icon", { attrs: { name: "file-text-o" } }),
            _vm._v(" "),
            _c("span", { staticClass: "dt-group-btn-func-btn-left-text" }, [
              _vm._v("SAVE MESSAGE")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-button",
          {
            staticClass: "item-cancel-btn",
            on: {
              click: function($event) {
                _vm.hideModal()
              }
            }
          },
          [
            _c("span", { staticClass: "dt-group-btn-func-btn-left-text" }, [
              _vm._v("CANCEL")
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-subtitle" }, [
      _vm._v("\n    You are submitting event "),
      _c("span", { staticClass: "blue" }, [_vm._v("(Event name here)")]),
      _vm._v(" for approval.\n  ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-859f0632", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-859f0632","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/CustomMessageSectionSubmission.vue
// module id = 1601
// module chunks = 1